import React from 'react';
import { Zap, Eye, Network, Power, Phone, Lock, Loader2 } from 'lucide-react';

export const StatusBadge = ({ status }) => {
  const statusMap = {
    pending: 'badge-pending',
    assigned: 'badge-assigned',
    in_progress: 'badge-in-progress',
    completed: 'badge-completed',
    cancelled: 'badge-cancelled',
    draft: 'badge-pending',
    sent: 'badge-assigned',
    paid: 'badge-completed',
    overdue: 'badge-cancelled'
  };
  return (
    <span className={`badge ${statusMap[status] || 'badge-pending'}`}>
      {status.replace('_', ' ')}
    </span>
  );
};

export const PriorityBadge = ({ priority }) => {
  const priorityMap = {
    urgent: 'badge-urgent',
    high: 'badge-high',
    medium: 'badge-medium',
    low: 'badge-low'
  };
  return (
    <span className={`badge ${priorityMap[priority] || 'badge-medium'}`}>
      {priority}
    </span>
  );
};

export const ServiceIcon = ({ type, className = 'w-5 h-5' }) => {
  const icons = {
    electrical: Zap,
    cctv: Eye,
    networking: Network,
    generator: Power,
    intercom: Phone,
    access_control: Lock
  };
  const Icon = icons[type] || Zap;
  return <Icon className={className} />;
};

export const LoadingSpinner = () => (
  <div className="flex items-center justify-center p-8">
    <Loader2 className="w-8 h-8 text-white animate-spin" />
  </div>
);
